module.exports = __webpack_public_path__ + "static/media/bg1.99188e8f.jpg";